/**
 * useAcceptErrorHandler
 *
 * Builds the shared `onError` handler for the whole-offer Accept mutation —
 * previously duplicated verbatim in client-offer-page.tsx (SSO) and
 * public-offer-page.tsx (public link). Non-200 errors aren't toasted
 * globally (MutationCache fallback would show the raw backend message) — a
 * 409 means the version was superseded server-side (another client/staff
 * republish raced this accept) and needs a specific "refresh" prompt,
 * mirroring v1's ClientOfferAcceptButton isSuperseded handling. Every other
 * error falls back to apiErrorToUserMessage's generic mapping.
 */
import { useTranslation } from 'react-i18next';
import { toast } from '@ooh/ui/components/sonner';
import { parseApiError } from '@ooh/contracts';
import { apiErrorToUserMessage } from '../../../lib/api-error-messages';

export function useAcceptErrorHandler(): (error: unknown) => void {
  const { t } = useTranslation('offers');

  return (error: unknown) => {
    const parsed = parseApiError(error);
    if (parsed.statusCode === 409) {
      toast.error(t('clientOffer.footer.supersededMessage'));
    } else {
      toast.error(apiErrorToUserMessage(parsed, 'mutation'));
    }
  };
}
